import React, { useState } from "react";
import { Button } from "../ui/button";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { useGetOrderQuery } from "../../store/api/orderApi";
import { toast } from "react-toastify";
import { CreatableCombobox } from "../CreatableCombobox";
import { DialogClose } from "@radix-ui/react-dialog";

const AssignAccountModal = ({ isOpen, onClose, id }) => {
  const { data, isLoading, error } = useGetOrderQuery(id);
  const [account, setAccount] = useState();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Assign an Account</DialogTitle>
        </DialogHeader>

        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <Loader2 className="h-6 w-6 animate-spin text-primary" />
            <span className="ml-2">Loading data...</span>
          </div>
        ) : error ? (
          <div className="text-center py-8 text-destructive">
            Error loading order data. Please try again.
          </div>
        ) : (
          <>
            <div className="w-full mx-auto bg-white rounded-lg overflow-hidden">
              <div className="space-y-2">
                <label className="block text-sm font-normal text-muted-foreground">
                  Select an existing account or add a new one
                </label>
                <CreatableCombobox
                  items={["1234", "5678", "9123"]}
                  value={account}
                  onSelect={(item) => setAccount(item)}
                  classes={{ button: "w-full", popoverContent: "w-96" }}
                />
              </div>
            </div>
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="outline" size="sm" type="button">
                  Cancel
                </Button>
              </DialogClose>
              <Button type="submit" size="sm">
                Save changes
              </Button>
            </DialogFooter>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AssignAccountModal;
